<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i class="bi bi-upload"></i>
        Carga masiva de productos
      </h6>
    </div>

    <div class="form-card__body">
      <p class="form-card__hint" style="font-size: 13px; margin-bottom: 16px;">
        Para proceder con la importación masiva de productos, lo primero que debemos hacer es bajar el archivo de ejemplo. Luego lo abriremos en un editor de hojas de cálculo e ingresaremos todos los productos en el orden correcto. Para finalizar, subí el archivo al sistema y la importación será inmediata.
      </p>

      <div class="form-card__field">
        <a href="#" class="form-card__btn" @click.prevent="downloadTemplate">
          <i class="bi bi-download"></i>
          Bajar archivo Guía de Productos
        </a>
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="import-file">Subir archivo</label>
        <input
          id="import-file"
          type="file"
          class="form-control"
          accept=".csv,.xls,.xlsx"
          @change="selectedFile"
        >
        <div v-if="file" class="form-card__hint">{{ file.name }}</div>
        <div v-else class="form-card__hint">Seleccione un archivo .csv, .xls o .xlsx</div>
      </div>
    </div>

    <div class="form-card__footer">
      <button
        type="button"
        class="form-card__btn form-card__btn--primary"
        :disabled="!file"
        @click="importar"
      >
        <i class="bi bi-check-lg"></i>
        Importar archivo
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: null,
    };
  },
  methods: {
    selectedFile(event) {
      this.file = event.target.files[0] || null;
    },
    downloadTemplate() {
      // TODO: implementar descarga del archivo de ejemplo
    },
    importar() {
      if (!this.file) return;
      // TODO: implementar subida del archivo
    },
  },
};
</script>
